module.exports = __webpack_public_path__ + "static/media/kshitij.05d1bd8a.jpg";